/**
 * Analytics Utilities
 * Google Analytics 4 dataLayer event tracking
 * 
 * Usage in custom blocks:
 * import { trackEvent, trackCtaClick, trackCardClick } from './analytics';
 * trackEvent('custom_event', { key: 'value' });
 * trackCtaClick('Button Text', 'https://example.com');
 * trackCardClick('Card Title', 'https://example.com', 'company');
 * 
 * Or import everything:
 * import * as Analytics from './analytics';
 * Analytics.trackEvent('custom_event', { key: 'value' });
 */

// ===================
// ### Track Custom Event
export const trackEvent = (eventName, eventData = {}) => {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Push event to dataLayer
  window.dataLayer.push({
    event: eventName,
    ...eventData
  });

   console.log('📊 GA4 Event tracked:', eventName, eventData);

  if (typeof jump_debug === 'function') {
    jump_debug('📊 GA4 Event tracked:', eventName, eventData);
  }
};

// ===================
// ### Track Navigation Clicks
export const trackNavClick = (linkText, linkUrl) => {
  trackEvent('nav_click', {
    click_text: linkText,
    click_url: linkUrl,
  });
};

// ===================
// ### Track CTA Clicks
export const trackCtaClick = (linkText, linkUrl) => {
  if (!linkText || !linkUrl) return;
  
  trackEvent('cta_click', {
    click_text: linkText,
    click_url: linkUrl,
  });
};

// ===================
// ### Track Industries Card Clicks
export const trackIndustriesCardClick = (cardTitle, cardUrl, cardType = '') => {
  if (!cardTitle || !cardUrl) return;
  
  trackEvent('industries_click', {
    card_title: cardTitle,
    card_url: cardUrl,
    card_type: cardType,
  });
};

// ===================
// ### Track State Comparison
export const trackStateComparison = (selectedState, selectedAction = '') => {
  if (!selectedState) return;

  trackEvent('state_comparison', {
    selected_state: selectedState,
    selected_action: selectedAction,
  });
};

// ===================
// ### Track Outbound Link Clicks
export const trackOutboundLinkClick = (linkText, linkUrl) => {
  if (!linkText || !linkUrl) return;
  
  trackEvent('outbound_click', {
    click_text: linkText,
    click_url: linkUrl,
  });
};

// ===================
// ### Track Data Comparison Category Selection
export const trackDataComparisonSelection = (category, statesCompared = '') => {
  if (!category) return;
  
  trackEvent('data_comparison_selection', {
    category: category,
    states_compared: statesCompared,
  });
};

// Default export with all methods
export default {
  trackEvent,
  trackNavClick,
  trackCtaClick,
  trackIndustriesCardClick,
  trackStateComparison,
  trackOutboundLinkClick,
  trackDataComparisonSelection
};
